const EMPTY = {
    byUserId: {},
    users: [],
    placeholders: []
};
export const Memberships = {
    empty: ()=>EMPTY,
    set: ([, userId], memberType, joinedAt)=>({ byUserId, users, placeholders })=>({
                users: users.filter((x)=>x !== userId).concat(userId),
                byUserId: {
                    ...byUserId,
                    [userId]: {
                        memberType,
                        joinedAt
                    }
                },
                placeholders
            }),
    reset: ([, userId])=>({ byUserId, users, placeholders })=>({
                users: users.filter((x)=>x !== userId),
                placeholders,
                byUserId: {
                    ...byUserId,
                    [userId]: undefined
                }
            }),
    find: ([, userId])=>({ byUserId })=>byUserId[userId],
    exists: ([, userId])=>({ users })=>users.some((x)=>x === userId)
};
